import { getMessages } from './getMessages'
import { getUnreadStatus } from './getUnreadStatus'
import { Conversation, ConversationItem } from '../models'

export type BaseConversationItemProps = Pick<
  ConversationItem,
  'fetching' | 'joining' | 'messages' | 'participants' | 'updating'
>

export const initialConversationItem: BaseConversationItemProps = {
  fetching: 'IDLE',
  joining: 'IDLE',
  updating: 'IDLE',
  messages: [],
  participants: [],
}

export const getConversationItem = (
  { lastMessage, ...data }: Conversation,
  participantIds: number[],
  unreadList: number[],
  previousConversation?: ConversationItem
): ConversationItem => {
  const { profileId, userId } = data.participants[0]

  if (data.context?.unitId || data.context?.projectId) {
    data.context.listingId = data.context?.unitId || data.context?.projectId
  }
  const messages = getMessages(lastMessage, previousConversation?.messages)

  const unread = getUnreadStatus(data.id, unreadList)

  return {
    ...initialConversationItem,
    ...data,
    profileId,
    userId,
    messages,
    unread,
    total: previousConversation?.total ?? 0,
  }
}
